<template>
  <div class="exception-body notfound">
    <div class="exception-content">
      <div class="exception-detail my-4"><h3>{{$t('notFound_title')}}</h3></div>
      <router-link :to="isSda ? '/users' : '/'">
        <Button class="button-add-tag-new" style="width: 250px">{{$t('notFound_label_goHomePage')}}</Button>
      </router-link>
    </div>
  </div>
</template>

<script>
import { useBreadcrumbStore } from "../stores/breadcrumb.js";
import { mapState, mapActions } from "pinia";
import { useLoginStore } from "../stores/login.js";
export default {
  data() {
    return {
    }
  },
  computed: {
    ...mapState(useLoginStore, ["getAbacConfig"]),
    isSda() {
      return this.getAbacConfig?.role_def?.subtenant?.length==1 && this.getAbacConfig?.role_def?.subtenant?.[0] === 'sda';
    }
  },
  mounted() {
    this.setBreadcrumb( [{ label: this.$t('breadCrumb_notFound')}] );
  },
  methods: {
    ...mapActions(useBreadcrumbStore, ["setBreadcrumb"]),
  }
}
</script>
